import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

export default function CallbackPage() {

  const [isProcessing, setIsProcessing] = useState<boolean>(true);
  const [isSuccess, setIsSuccess] = useState<boolean>(false);
  const [urlSearchParams] = useSearchParams();
  const code = urlSearchParams.get("code");
  const iss = urlSearchParams.get("iss");
  const state = urlSearchParams.get("state");

  useEffect(() => {

    if (code && iss && state) {

      (async () => {

        const response = await fetch(`https://postoad-api.beastslash.com/callback?${urlSearchParams.toString()}`, {
          method: "POST"
        });

        if (response.ok) {

          setIsSuccess(true);

        } else {

          setIsProcessing(false);

        }

      })();

    } else {

      setIsProcessing(false);

    }

  }, [code, iss, state]);

  return (
    <main>
      <section>{isSuccess ? "done! you may now close the window" : (isProcessing ? "processing..." : `couldn't authenticate you. try running "/accounts authorize" again.`)}</section>
    </main>
  );

}